import { ReactNode } from "react";

import type { SxProps } from "@mui/material/styles";
import { type Variant } from "@mui/material/styles/createTypography";

import usePracticeVoiceEnabled from "hooks/use-practice-voice-enabled.hook";
import { Patient } from "services/types/patients.type";
import { isNotBlank } from "utils/common";

import CallPatientLinkContent from "./call-patient-link-content.component";

type CallPatientLinkProps = {
  children: ReactNode;
  label?: ReactNode;
  patient?: Partial<Patient>;
  phoneNumber?: string | null;
  variant?: Variant;
  redirect?: boolean;
  sx?: SxProps;
  containerSx?: SxProps;
};
export default function CallPatientLink({
  patient,
  label,
  phoneNumber,
  variant,
  redirect,
  sx,
  containerSx,
  children
}: CallPatientLinkProps) {
  const isPracticeVoiceEnabled = usePracticeVoiceEnabled();

  if (!isPracticeVoiceEnabled) return <>{children}</>;

  const phone = [phoneNumber, patient?.phone, patient?.secondary_phone]
    .filter(isNotBlank)
    ?.at(0);

  if (!phone) return <>{children}</>;

  return (
    <CallPatientLinkContent
      label={label}
      phoneNumber={phone}
      patient={patient}
      variant={variant}
      redirect={redirect}
      sx={sx}
      containerSx={containerSx}
    />
  );
}
